import React from 'react';
import { Form, Modal, message } from 'antd';
import apis from '../../apis/index';
const ref = React.createRef();
export default class Dialogcms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      resourceName: '',
      startTme: '',
    };
  }

  handleOk = async () => {
    this.handleApplyResource();
  };

  handleApplyResource = async () => {
    const option = [];
    option.planCode = this.planCode;
    option.resourceId = this.resourceId;
    const result = await apis.fetchResourceApply(option);

    if (result.ret === '0') {
      this.handleCancel();
      message.success('申请成功');
      this.props.onSuccess();
    } else {
      this.props.onFailed && this.props.onFailed();
      message.error(result.msg);
    }
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
    console.log(e);
  };

  showModal = (planCode, resourceId, resourceName, startTime) => {
    this.planCode = planCode;
    this.resourceId = resourceId;
    this.setState({
      visible: true,
      resourceName: resourceName,
      startTime: startTime,
    });
  };

  componentDidMount() {}

  render() {
    return (
      <div className="card-container">
        <Modal
          title="提交申请"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="提交"
          cancelText="取消"
        >
          <Form ref={ref} name="nest-messages">
            <Form.Item name="erp" label="资源位名称">
              <span>{this.state.resourceName}</span>
            </Form.Item>

            <Form.Item name="erp" label="生效时间">
              <span>{this.state.startTime}</span>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }
}
